import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { PANEL_ACCESS_DENIED, googleSignInMessage } from "../../../Utils/panelAdminAccess";
import {
  signInPanelWithGoogle,
  watchPanelSession,
} from "../../../Utils/panelAdminSession";
const Login = () => {
  const navigate = useNavigate();
  const signingIn = React.useRef(false);
  useEffect(() => {
    if (typeof sessionStorage !== "undefined" && sessionStorage.getItem("panel_access_denied") === "1") {
      sessionStorage.removeItem("panel_access_denied");
      toast.error(PANEL_ACCESS_DENIED);
    }
    return watchPanelSession(async (state) => {
      if (signingIn.current) return;
      if (state.status === "ok") {
        navigate("/admin/dashboard");
        return;
      }
      if (state.status === "denied") {
        toast.error(PANEL_ACCESS_DENIED);
      }
    });
  }, [navigate]);
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const handleGoogleSignIn = async () => {
    setIsGoogleLoading(true);
    signingIn.current = true;
    try {
      const decision = await signInPanelWithGoogle();
      if (!decision || decision.status !== "ok") {
        toast.error(PANEL_ACCESS_DENIED);
        return;
      }
      navigate("/admin/dashboard");
      toast.success("Login Successful.");
    } catch (error) {
      toast.error(googleSignInMessage(error && error.code) || error.message);
    } finally {
      signingIn.current = false;
      setIsGoogleLoading(false);
    }
  };
  return (
    <>
      <Box
        sx={{
          background: "linear-gradient(167.96deg, #353535 0%, #000000 100%)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
        }}
      >
        <Box
          sx={{
            width: "100%",
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
          }}
        >
          <Box
            sx={{
              width: { xs: "95%", sm: "60%", md: "50%", lg: "40%", xl: "30%" },
            }}
          >
            <Box
              sx={{
                width: "100%",
                border: "3px solid rgba(42, 245, 152, 1)",
                // box-shadow: 0px 4px 20.8px 0px #00000040;
                backgroundColor: "#00000040",
                borderRadius: "30px",
                py: 1,
                position: "relative",
                zIndex: "3",
                boxShadow: "0px 4px 20.8px 0px #00000040",
                opacity: 1,
              }}
            >
              <Box sx={{ height: "100%", width: "100%", p: 3 }}>
                <Typography
                  sx={{
                    fontSize: "35px",
                    fontWeight: "600",
                    color: "#fff",
                    fontFamily: "Outfit",
                    textAlign: "center",
                  }}
                >
                  Welcome Back!
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#fff",
                    fontFamily: "Outfit",
                    textAlign: "center",
                  }}
                >
                  Sign in with your Google account.
                </Typography>

                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "1rem",
                    paddingTop: "30px",
                  }}
                >
                  <Box sx={{ width: "55%" }}>
                    <Button
                      type="button"
                      fullWidth
                      disabled={isGoogleLoading}
                      onClick={handleGoogleSignIn}
                      sx={{
                        borderRadius: "15px",
                        border: "1px solid rgba(42, 245, 152, 1)",
                        color: "#fff",
                        textTransform: "none",
                        fontFamily: "Outfit",
                        fontWeight: 500,
                        fontSize: "16px",
                        py: 1,
                      }}
                    >
                      {isGoogleLoading ? "Login..." : "Login"}
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Login;
